export enum TemplateAttributeMode {

  DEFAULT = 'DEFAULT', DISABLED = 'DISABLED', HIDDEN = 'HIDDEN'

}
